import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";
import AdminUpdatesPopup from "../admin/updates/AdminUpdatesPopup";

export default function RequireRole({ allowed = [] }) {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (!user) return <Navigate to="/" replace />;

  const role = (user.access_type || "").toUpperCase();
  const ok = allowed.map(r => r.toUpperCase()).includes(role);
  const isAdminScope = allowed.map((r) => r.toUpperCase()).includes("ADMIN");

  if (!ok) return <Navigate to={role === "ADMIN" ? "/admin/dashboard" : "/dashboard"} replace />;

  return (
    <>
      {role === "ADMIN" && isAdminScope ? <AdminUpdatesPopup user={user} /> : null}
      <Outlet />
    </>
  );
}
